<template>
  <Alert show-icon>
    未激活/激活失效
    <Icon type="ios-bulb-outline" slot="icon"></Icon>
    <template slot="desc">请联系管理员激活</template>
  </Alert>
</template>

<script>
export default {
  name: 'not-active',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
